import React from "react";
import { STRINGS } from "../../../../strings";
import { translate } from "../../../../translate";
import { PASSPORT_SVG } from "../../../../utils/svgs";
import { AppCard, AppCardContent } from "../../../Generic/AppCard";
import { AppIcon } from "../../../Generic/AppIcon";

const PassportExplainerCard = () => {
  return (
    <AppCard className="PassportExplainerCard">
      <AppCardContent>
        <div className="_iconWrapper">
          <AppIcon icon={PASSPORT_SVG} fill="white" stroke="white" />
        </div>
        <div className="_name">
          <span>{translate(STRINGS.UPLOAD_YOUR_FILES_TO_ENSURE)}</span>
          <strong>{translate(STRINGS.YOUR_COMPLIANCE)}</strong>
        </div>
      </AppCardContent>
    </AppCard>
  );
};

export default React.memo(PassportExplainerCard);
